import reducer from './userMonthlyConsumptionReducer';
import actions from './userMonthlyConsumptionActions';
import createProvider from '../../utilities/createProvider';

export default createProvider(actions, reducer);
